import { Directive, ElementRef, inject, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { LoaderSpinnerComponent } from '@ui/loader-spinner/loader-spinner.component';
import { DynamicOverlay } from './dynamic-overlay';

@Directive({
  selector: '[appLoader]',
})
export class LoaderDirective implements OnChanges, OnDestroy {
  private readonly targetEl = inject(ElementRef);
  private readonly dynamicOverlay = inject(DynamicOverlay);

  @Input({ required: true }) appLoader!: boolean;
  @Input() hasBackdrop = true;

  private overlayRef: OverlayRef;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.appLoader) {
      this.toggleLoader();
    }
  }

  private toggleLoader() {
    if (this.appLoader) {
      this.dynamicOverlay.setContainerElement(this.targetEl.nativeElement);
      this.overlayRef = this.dynamicOverlay.create({
        positionStrategy: this.dynamicOverlay.position().global().centerHorizontally().centerVertically(),
        hasBackdrop: this.hasBackdrop,
        backdropClass: 'app-loader-overlay',
      });
      this.overlayRef.attach(new ComponentPortal(LoaderSpinnerComponent));
    } else {
      this.hideLoader();
    }
  }

  private hideLoader() {
    this.overlayRef?.detach();
    this.overlayRef?.dispose();
  }

  ngOnDestroy(): void {
    this.hideLoader();
  }
}
